import { useQuery } from "urql";

import {
  DashboardNextMonthDueDocument,
  QueryDashboardNextMonthDueArgs,
} from "../../../graphql/generated.ts";

export const useDashboardNextMonthDue = (
  variables: QueryDashboardNextMonthDueArgs
) => {
  return useQuery({
    query: DashboardNextMonthDueDocument,
    variables,
  });
};
